export const SkillsCard = ({ skill, imgUrl }) => {
    return (
        <div className="item">
            <img src={imgUrl} alt="skill" />
            <h5>{skill}</h5>
        </div>
    )
}